import type { Router } from 'vue-router';
import { getUsrInfo } from '../api/auth';
import { getToken } from '../service/TokenManage';

// 白名单路由 - 不需要认证的页面
const whiteList = ['/login', '/404'];

// 封装跳转到登录页的逻辑
const redirectToLogin = () => {
  // 清除过期的token
  localStorage.clear();

  const mode = import.meta.env.MODE;
  if (mode === 'development') {
    window.location.href = 'http://localhost:8000/login';
  } else if (mode === 'test') {
    window.location.href = 'https://aiot-qa.zuowei.com/login';
  } else {
    window.location.href = 'https://aiot.zuowei.com/login';
  }
};

export function setupRouterGuards(router: Router) {
  // 全局前置守卫 - 简化的身份验证
  router.beforeEach(async (to, from, next) => {
    console.log('\n🛡️ 路由守卫检查:', {
      from: from.path,
      to: to.path,
      query: to.query
    });

    // 检查是否在白名单中
    const inWhiteList = whiteList.includes(to.path);

    // 子应用路径也放行（由子应用自己处理认证）
    const isSubApp = to.path.startsWith('/sub-app/');

    // 如果是白名单路径或子应用路径，直接放行
    if (inWhiteList || isSubApp) {
      console.log('✅ 路由守卫：白名单或子应用路径，允许访问');
      next();
      return;
    }

    // 检查是否有token
    const token = getToken();
    if (!token) {
      console.log('路由守卫：未认证，重定向到登录页');
      redirectToLogin();
      return;
    }

    // 如果有token，验证token有效性
    try {
      const res = await getUsrInfo();
      const { code = 1 } = res || {};

      // 如果token有效，继续导航
      if (code === 0) {
        console.log('✅ 路由守卫：token有效，允许访问');
        next();
      } else {
        // token无效，清除并跳转到登录页
        console.log('路由守卫：token无效，重定向到登录页');
        redirectToLogin();
      }
    } catch (error) {
      // 接口调用失败，认为token无效
      console.log('路由守卫：token验证失败，重定向到登录页', error);
      redirectToLogin();
    }
  });

  // 全局后置守卫
  router.afterEach(to => {
    // 设置页面标题
    // 先隐藏（由子应用设置）
    // document.title = to.meta?.title ? `${to.meta.title} - AIMS` : 'AIMS';
  });
}
